export default __webpack_public_path__ + "static/media/caretOrange.5cebf7d7.svg";